import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AlertsContainer from '../state/AlertsContainer';
import CurrentUserContainer from '../state/CurrentUserContainer';

export const usePasswordManager = () => {
    const { t } = useTranslation();
    const alertsContainer = AlertsContainer.useContainer();
    const currentUserContainer = CurrentUserContainer.useContainer();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');

    const handleSavePassword = async () => {
        try {
            if (!validatePasswordInputs()) return;

            const result = await currentUserContainer.updatePassword(oldPassword, newPassword, confirmNewPassword);
            handlePasswordSaveResult(result);
        } catch (error) {
            console.error('Failed to update password:', error);
            alertsContainer.showError(t('common:account.error.generic'));
        }
    };

    const validatePasswordInputs = () => {
        if (!oldPassword) {
            alertsContainer.showError(t('common:account.error.old'));
            return false;
        }
        if (!newPassword) {
            alertsContainer.showError(t('common:account.error.new'));
            return false;
        }
        if (newPassword !== confirmNewPassword) {
            alertsContainer.showError(t('common:account.error.match'));
            return false;
        }
        return true;
    };

    const handlePasswordSaveResult = (result: any) => {
        if (result?.resultType === 'Ok') {
            alertsContainer.showSuccess(t('common:account.success.password'));
            resetPasswordFields();
        } else {
            alertsContainer.showError(result?.errors?.join(', ') ?? t('common:account.error.password'));
        }
    };

    const resetPasswordFields = () => {
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    };

    return {
        oldPassword,
        newPassword,
        confirmNewPassword,
        setOldPassword,
        setNewPassword,
        setConfirmNewPassword,
        handleSavePassword,
    };
};
